import { Component, Input, OnInit, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetService } from '../../services/asset.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { UtilityService } from 'src/app/services/utility.service';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { FilterService } from '../../services/filter.service';
import * as moment from 'moment';
import { AssetsAllocationModalComponent } from '../assets-allocation-modal/assets-allocation-modal.component';


@Component({
  selector: 'app-asset-list',
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.scss']
})
export class AssetListComponent implements OnInit {

  @Input('asset') assetData
  @Input('userDetails') userDetails
  @Input('user') userObj;
  @Input('parentCard') selectedCard
  @Input('assetCounts') totalCounts
  bgColors: string[];
  lastColor;
  userId
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  assetList = []
  loading
  displayedColumns: string[]
  filterActive: boolean = false
  afterFilter
  isSpinnerId
  isSpinner: boolean = false
  user
  isAsset: boolean = false
  isAssetTitle: boolean = false
  currentUser
  isDashboard = false
  tempDataSource: [];
  totalAssets
  currentCard: string
  noAssetmsg = 'Sorry, No Asset Added yet!'
  noDueAssetmsg = 'Sorry, No Upcoming Due for Inspection Asset!'
  noAssignedAssetmsg = 'Sorry, No Asset Assigned to any Users yet!'
  noUnassignedAssetmsg = 'Sorry, No Unassigned Asset!'


  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @Output() assetValid: EventEmitter<any> = new EventEmitter<any>();


  constructor(
    public _assetService: AssetService,
    private router: Router,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
    public _filter: FilterService
  ) {
    this.bgColors = ["badge-red", "badge-teal", "badge-blue", "badge-yellow", "badge-pink"];
    this.dataSource = new MatTableDataSource()
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    let url = this.router.url.split('/')
    if ((url.includes('asset') || url.includes('asset-list')) && !this.currentUser.userRole.includes('admin')) {
      this.userId = this.currentUser.userId
      this.getUserAssetList()
      this.setDynamicColumn(false)
    }
    if (url.includes('asset-list')) this.isAssetTitle = true
    this._assetService.closeDisplayFile(true)
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedCard && changes.selectedCard.currentValue) this.currentCard = changes.selectedCard.currentValue
    if (changes.userObj && changes.userObj.currentValue) {
      this.userId = changes.userObj.currentValue.userId._id
      this.getUserAssetList()
      this.setDynamicColumn(false)
    }
    console.log("user data changes in sub page", changes);
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetList = changes.assetData.currentValue
      this.setDynamicColumn(true)
      this.updateData(this.assetList)
      this.isDashboard = true
    }
    if (changes.totalCounts && changes.totalCounts.currentValue) this.totalAssets = changes.totalCounts.currentValue
  }



  // UTILITY

  // dataSource = ELEMENT_DATA;

  getRandomColorClass(i) {
    let rand = Math.floor(Math.random() * this.bgColors.length);
    rand = i % 5;
    this.lastColor = rand;
    return this.bgColors[rand];
  }

  onActivate(event) {
    console.log("%c Event in asset component", "font-size:30px; color: red", event)
  }



  setDynamicColumn(flag) {

    if (flag) this.displayedColumns = ['title', 'id', 'assettype', 'nextInspectionDate', 'Action']
    else this.displayedColumns = ['title', 'id', 'date', 'sites', 'linkedasset', 'action'];
    console.log("WHAT IS IN THE FLAG", flag, this.displayedColumns);

  }

  updateData(data) {
    console.log("UPDATING DATA = ", data)
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'id': return item.uniqueId;
        case 'date': return item.createdAt;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    if (data && data.length <= 0) {
      this.filterActive = true;
      let nodatamsg
      if (this.currentCard == 'isTotal') nodatamsg = this.noAssetmsg
      if (this.currentCard == 'isDue') nodatamsg = this.noDueAssetmsg
      if (this.currentCard == 'isAssigned') nodatamsg = this.noAssignedAssetmsg
      if (this.currentCard == 'isUnassigned') nodatamsg = this.noUnassignedAssetmsg


      this.afterFilter = {
        title: "No Asset",
        data: nodatamsg
      }
    } else this.filterActive = false
  }


  viewSingleAsset(asset) {
    this.router.navigate(['/asset/single-asset/' + asset.uniqueId])
  }

  assetAssignList(asset) {
    console.log("SINGLE ASSET DATA", asset);
    let obj = {
      asset: asset,
      count: this.totalAssets
    }
    this._utilityService.commonDialogBoxOpen(AssetsAllocationModalComponent, obj).afterClosed().subscribe((data) => {

    })

  }

  filter(searchText) {
    this.afterFilter = null
    this.filterActive = false;
    // console.log('FILTER CALLED', searchText, this.isToogle);
    if (searchText === '') {
      this.updateData(this.assetList);
      return;
    }
    console.log("filter Time pass data..", this.assetList)
    this.tempDataSource = this._filter.filter(searchText, this.assetList, ['title', 'uniqueId', 'assettype'], 'newfilter');
    this.updateData(this.tempDataSource)
    console.log("tempDataSource-->", this.tempDataSource, this.loading, this.filterActive);
    if (this.tempDataSource.length <= 0) {
      this.filterActive = true;
      this.afterFilter = {
        title: "No Asset",
        data: "Sorry, no asset matched your search"
      }
    }
  }

  inspectionForm(element) {
    console.log("element", element);
    if (element.assetType == '008') {
      console.log("this is for safety");
      this.router.navigate(['/asset/handheld/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    } else if (element.assetType == '002') {
      this.router.navigate(['/asset/vehicle/' + element.uniqueId], { queryParams: { 'user': this.userId, '_userDVN': this.currentUser.name, '_regNum': (element.assetList.documentId && element.assetList.documentId.details && element.assetList.documentId.details.vehicleReg) ? element.assetList.documentId.details.vehicleReg : '' } })
    } else if (element.assetType == '003') {
      this.router.navigate(['/asset/safety/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    }
    else if (element.assetType == '007') {
      this.router.navigate(['/asset/handtool/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    } else if (element.assetType == '006') {
      this.router.navigate(['/asset/medical/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    } else if (element.assetType == '004') {
      this.router.navigate(['/asset/safety-critical/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    } else if (element.assetType == '009') {
      this.router.navigate(['/asset/ironman/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    } else if (element.assetType == '010') {
      this.router.navigate(['/asset/handtrolley/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    }
    else {
      this.router.navigate(['/asset/inspection/' + element.uniqueId], { queryParams: { 'user': this.userId } })
    }
  }

  downloadAssets(value) {
    console.log("value----->", value);

    this.isSpinnerId = value.uniqueId;
    this.isSpinner = true
    let obj = {
      userId: value.assetList.userId,
      assetDetails: value.assetList.documentId,
      assetsId: value.assetList.documentId._id,
      submissionDate: value.assetList.updatedAt
    }
    console.log("here is the assets user Id========>", obj)

    this._assetService.downloadAssetPdf(obj).subscribe((data) => {
      console.log("here is the response ====>", data)
      // console.log("formname---->", this.formName);
      const downloadLink = document.createElement("a");
      const fileName = moment(new Date(obj.submissionDate)).format("MM-DD-YYYY") + ".pdf";
      downloadLink.href = data.pdfUrl;
      downloadLink.download = fileName;
      downloadLink.click();
      this._utilityService.handleSnackBar({ msg: "File downloaded successfully!", button: "Ok" })
      this.isSpinner = false;
      this.isSpinnerId = null
    }, (error) => {
      console.log("here is the error ===>", error)
      this._utilityService.handleSnackBar({ msg: "File download failed!", button: "Ok" })
      this.isSpinner = false
      this.isSpinnerId = null
    }
    )
  }

  // API CALL

  getUserAssetList() {
    this.loading = true;
    this._assetService.getUserAssetsList(this.userId).subscribe((res) => {
      console.log("res of assets list", res);
      this.loading = false;
      if (res && res.length) {
        this.assetList = res
        this.assetValid.emit({ isAsset: true })
        console.log("call the ASSET LIST!!", this.assetList)
      }
      else {
        // this.filterActive = true
        // this.afterFilter = {
        //   title: "No Assets!",
        //   data: "Sorry, no Assets added yet!!"
        // }
        this.assetValid.emit({ isAsset: false })
      }
      this.updateData(this.assetList)
    }, err => {
      console.log("err", err);
      this.loading = false;
    })

  }


}
